import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaInstagram } from 'react-icons/fa';
import { logoWhiteSimpleImage } from '../assets/images';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <FooterContent>
        <FooterLogo>
          <Link to="/">
            <LogoContainer>
              <img src={logoWhiteSimpleImage} alt="TK DJ Services Logo" />
              <LogoText>TK DJ SERVICES</LogoText>
            </LogoContainer>
          </Link>
          <p>Premier DJ, Audio, and Lighting Services in the DMV</p>
        </FooterLogo>
        
        <FooterLinks>
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/dj-services">DJ Services</Link></li>
            <li><Link to="/keen-acoustic-sciences">Keen Acoustic Sciences</Link></li>
            <li><Link to="/lighting-production">Lighting Production</Link></li>
            <li><Link to="/vinyl-sales">Vinyl & Equipment</Link></li>
          </ul>
        </FooterLinks>
        
        <FooterContact>
          <h3>Contact Us</h3>
          <ContactItem>
            <FaPhone />
            <span>301-928-8940</span>
          </ContactItem>
          <ContactItem>
            <FaEnvelope />
            <span>TKDJServicesUnltd@gmail.com</span>
          </ContactItem>
          <ContactItem>
            <FaMapMarkerAlt />
            <span>Damascus, MD - Serving the DMV Area</span>
          </ContactItem>
          <SocialIcons>
            <SocialIcon href="https://www.instagram.com/djtrev_ski" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </SocialIcon>
          </SocialIcons>
        </FooterContact>
      </FooterContent>
      
      <FooterBottom>
        <p>&copy; {currentYear} TK DJ Services. All Rights Reserved.</p>
      </FooterBottom>
    </FooterContainer>
  );
};

const FooterContainer = styled.footer`
  background-color: #0a0a0a;
  color: var(--color-tertiary);
  padding: 4rem 0 1rem;
`;

const FooterContent = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  padding-bottom: 2rem;
  border-bottom: 1px solid rgba(224, 221, 209, 0.1);
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
`;

const LogoText = styled.span`
  color: var(--color-white);
  font-size: 1.5rem;
  font-family: var(--font-accent);
  font-weight: 700;
  margin-left: 1rem;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

const FooterLogo = styled.div`
  img {
    height: 60px;
  }
  
  p {
    color: var(--color-tertiary);
    opacity: 0.8;
    max-width: 300px;
  }
`;

const FooterLinks = styled.div`
  h3 {
    color: var(--color-secondary);
    margin-bottom: 1.5rem;
    font-size: 1.2rem;
    font-family: var(--font-accent);
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
  
  ul {
    list-style: none;
  }
  
  li {
    margin-bottom: 0.8rem;
  }
  
  a {
    color: var(--color-tertiary);
    opacity: 0.8;
    transition: var(--transition);
    
    &:hover {
      opacity: 1;
      color: var(--color-secondary);
      padding-left: 5px;
    }
  }
`;

const FooterContact = styled.div`
  h3 {
    color: var(--color-secondary);
    margin-bottom: 1.5rem;
    font-size: 1.2rem;
    font-family: var(--font-accent);
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  
  svg {
    margin-right: 10px;
    color: var(--color-secondary);
  }
  
  span {
    opacity: 0.8;
  }
`;

const SocialIcons = styled.div`
  display: flex;
  margin-top: 1.5rem;
`;

const SocialIcon = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(65, 94, 78, 0.2);
  margin-right: 1rem;
  transition: var(--transition);
  
  svg {
    color: var(--color-secondary);
    font-size: 1.2rem;
  }
  
  &:hover {
    background-color: var(--color-primary);
    
    svg {
      color: var(--color-tertiary);
    }
  }
`;

const FooterBottom = styled.div`
  text-align: center;
  padding-top: 2rem;
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  
  p {
    opacity: 0.6;
    font-size: 0.9rem;
  }
`;

export default Footer; 